import { render, staticRenderFns } from "./workEdit.vue?vue&type=template&id=56fcf084"
import script from "./workEdit.vue?vue&type=script&lang=js"
export * from "./workEdit.vue?vue&type=script&lang=js"
import style0 from "./workEdit.vue?vue&type=style&index=0&id=56fcf084&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports